import React, { ReactElement, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useSelector, TypedUseSelectorHook, useDispatch } from "react-redux";

import { remove } from "redux/errors/errorsSlice";
import { RootState } from "redux/rootReducer";

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default function ErrorToast(): ReactElement {
  const dispatch = useDispatch();

  const errors = useTypedSelector((state) => state.errors);
  useEffect(() => {
    errors.forEach((item) => {
      toast.error(item.message, {
        onClose: () => dispatch(remove(item.id as string)),
      });
    });
  }, [errors, dispatch]);
  return (
    <div data-testid="error-toast">
      <ToastContainer />
    </div>
  );
}
